import * as React from 'react';
import { IconProps } from './types';

export const SlashIcon = ({ color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M4.10876 14L9.46582 1H10.8178L5.46074 14H4.10876Z" fill={color} fillRule="evenodd" clipRule="evenodd" />
    </svg>
  );
};

export default SlashIcon;
